import "firebase/firestore";
import * as firebase from "firebase/app";

var config = {
    apiKey: "AIzaSyBibSNZr6HSUJ1OtjGR5LhAVtY_E32KvII",
    authDomain: "photovoltaik.firebaseapp.com",
    databaseURL: "https://photovoltaik.firebaseio.com",
    projectId: "photovoltaik",
    storageBucket: "photovoltaik.appspot.com",
    messagingSenderId: "631534123587"
};
firebase.initializeApp(config);

let db = firebase.firestore();

export default class DbService {
    getAllData() {
        return db.collection("pvSimple");
    }

    getDailyData(date) {
        return db.collection("daily");
    }
}
